import { useState } from "react";
import dayjs from "dayjs";
import { useInterval } from "react-use";

type IntervalType = number | null;

type TIME_LEFT_UNIT = "d" | "h" | "m" | "s";

type POLL_STATE = {
    open: boolean;
    timeLeft?: number | undefined;
    units?: TIME_LEFT_UNIT | undefined;
};

export function usePollIsOpenState(
    pollClosedAt: string | undefined,
): POLL_STATE {
    const closedAtDate = dayjs(pollClosedAt);

    const [timeLeftValue, setTimeLeftValue] = useState<number>();
    const [timeLeftUnit, setTimeLeftUnit] = useState<TIME_LEFT_UNIT>();
    const [interval, setInterval] = useState<IntervalType>(100);

    useInterval(() => {
        const currentDate = dayjs();
        let timeLeftValue, timeLeftUnit: TIME_LEFT_UNIT | undefined;
        let interval: IntervalType = 60 * 1000;
        if (closedAtDate.diff(currentDate, "h") > 24) {
            timeLeftValue = closedAtDate.diff(currentDate, "day");
            timeLeftUnit = "d";
        } else if (closedAtDate.diff(currentDate, "h") >= 1) {
            timeLeftValue = closedAtDate.diff(currentDate, "h");
            timeLeftUnit = "h";
        } else if (closedAtDate.diff(currentDate, "s") > 60) {
            timeLeftValue = closedAtDate.diff(currentDate, "m");
            timeLeftUnit = "m";
            interval = 1000;
        } else if (closedAtDate.diff(currentDate, "s") >= 1) {
            timeLeftValue = closedAtDate.diff(currentDate, "s");
            timeLeftUnit = "s";
            interval = 1000;
        } else {
            interval = null;
        }
        setInterval(interval);
        setTimeLeftValue(timeLeftValue);
        setTimeLeftUnit(timeLeftUnit);
    }, interval);

    if (!pollClosedAt) {
        return {
            open: true,
        };
    }

    return {
        open: !!interval,
        timeLeft: timeLeftValue,
        units: timeLeftUnit,
    };
}
